import React from 'react';
import { Button } from 'react-bootstrap';
import CustomButtonStyles from './CustomRoundButton.module.scss';

type Props = {
  text: string;
  variant: 'primary' | 'outline-dark' | 'link';
  onClick: () => void;
  disabled?: boolean;
  rounded?: boolean;
  suffixIcon?: string;
  className?: string;
  isAnchor?: boolean;
  href?: string;
};

export const CustomRoundButton: React.FC<Props> = ({
  onClick,
  variant,
  disabled,
  rounded,
  text,
  suffixIcon,
  className,
  isAnchor,
  href,
}) => {
  return (
    <Button
      as={isAnchor ? 'a' : undefined}
      href={href}
      disabled={disabled}
      className={`${CustomButtonStyles.custom_button} ${
        rounded ? CustomButtonStyles.custom_button__rounded : ''
      } ${variant === 'primary' ? CustomButtonStyles.custom_button__primary : ''} ${
        variant === 'outline-dark' ? CustomButtonStyles.custom_button__outline_dark : ''
      } ${variant === 'link' ? CustomButtonStyles.custom_button__link : ''} ${className ?? ''}`}
      variant={variant}
      onClick={onClick}
    >
      {text}{' '}
      {suffixIcon && (
        <img
          className={CustomButtonStyles.custom_button__suffix_icon}
          src={suffixIcon}
          alt="arrow"
        />
      )}
    </Button>
  );
};
